module.exports = __webpack_public_path__ + "static/media/quansh_4x.9b844e72.svg";